import React from 'react'
import styled from '../../theme'

const Wrapper = styled.div`
  border-radius: 3px;
  background-color: #cecece;
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #696a6d;
  font-weight: bold;
  text-decoration: none solid rgb(105, 106, 109);
  text-align: center;
  margin-bottom: 5px;
  margin-right: 20px;
  padding: 5px 7px;
`

const mapStatus = status => {
  switch (status) {
    case 0:
      return '#cecece'
    case 1:
      return '#07a944'
    case 2:
      return '#ff5a5f'
  }
}

function Badge({ status, text }: IBadge) {
  return (
    <Wrapper
      style={{
        backgroundColor: mapStatus(status),
        color: status === 1 || status === 2 ? '#ffffff' : '#696a6d',
      }}
    >
      {text}
    </Wrapper>
  )
}

export interface IBadge {
  status: 0 | 1 | 2
  text: string
}

export default Badge
